import { createContext, useContext } from "react";
import { ManagementStore } from "./Management/ManagementStore";
import { StaffStore } from "./Staff/StaffStore";
import { ReportStore } from "./Report/ReportStore";
import { PublicStore } from "./Public/PublicStore";
import { DashBoardStore } from "./DashBoard/DashBoardStore";
import { PatientManagementStore } from "./PatientManagement/PatientManagementStore";
import { TreatmentManagementStore } from "./TreatmentManagement/TreatmentManagementStore";
import { FeeStore } from "./PatientManagement/PatientGeneral/PatientGeneralTabs/FeeTab/FeeStore";
import { AccountantStore } from "./Accountant/AccountantStore";

export const store = {
  managementStore: ManagementStore,
  staffStore: StaffStore,
  reportStore: ReportStore,
  publicStore: PublicStore,
  dashboardStore: DashBoardStore,
  patientManagementStore: PatientManagementStore,
  treatmentManagementStore: TreatmentManagementStore,
  feeStore: FeeStore,
  accountantStore: AccountantStore,
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
